import React, { useState } from "react";
import "./historylist.scss";
import { Typography } from "@mui/material";
import previewVideo from "../../../assets/images/previewVideo.svg";
import { Link } from "react-router-dom";
import ModalVideoPlayer from "../../plugInElements/ModalVideoPlayer";
import historyError from "../../../assets/images/historyError.svg";
import { getParams } from "../../../utlis/helpers";
import { pageLocale } from "../../../utlis/locale";

const HistoryList = ({ data }) => {
  const [videoShow, setVideoShow] = useState(false);
  const [videoUrl, setvideoUrl] = useState();
  const [landscape, setLandscape] = useState(false);
  const { accessToken, providerId, adminId, clientId } = getParams();
  const { view_report, test_videos, no_history } = pageLocale("history");
  const { locale } = getParams();
  const getDate = (date) => {
    const res = new Date(date);
    const month = res.toLocaleString("default", { month: "long" });
    const dateFinal = month + " " + res.getDate() + " " + res.getFullYear();
    // const dateForJa = res.getFullYear() + "  " + month + "  " + res.getDate();
    const times = res.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
      timeZone: "Asia/Tokyo",
    };
    let jstFormattedDate = res.toLocaleString("ja-JP", options);
    let hour = res.getHours();
    let amPm = hour < 12 ? "午前" : "午後";
    jstFormattedDate = jstFormattedDate.replace(/午前|午後/, "").trim(); // Remove default AM/PM
    let xx =
      locale === "ja" ? jstFormattedDate + " " + amPm : dateFinal + " " + times;
    return xx;
  };
  const videoPlayerHanndler = (link, moduleId) => {
    setVideoShow(true);
    setvideoUrl(link);
    if (moduleId === 1) {
      setLandscape(true);
    }
  };
  const videoPlayerCloseHandler = () => {
    setVideoShow(false);
    setvideoUrl();
    setLandscape(false);
  };

  return (
    <>
      {data?.length > 0 ? (
        data?.map((item, index) => {
          return (
            <div className="history-list-wrap" key={index}>
              <div className="test-name-wrap">
                <img src={item?.iconURL} alt="history-icon" className="img" />
                <Typography className="test-name">
                  {item?.moduleName}
                </Typography>
              </div>
              <div className="time-and-report-view-block">
                <Typography className="date-time">
                  {getDate(item?.reportTime)}
                </Typography>
                {item?.status === 1 && (
                  <Link
                    to={`${item?.reportURL}&isWebsite=true&accessToken=${accessToken}&providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`}
                  >
                    <button className="view-report-btn">{view_report}</button>
                  </Link>
                )}
              </div>
              {item?.previewUrl?.length > 0 && (
                <>
                  <div className="dashed-line"></div>
                  <div className="test-video-preview-block">
                    <Typography className="video-block-title">
                      {test_videos}
                    </Typography>
                    {item?.previewUrl?.map((subitem, index) => {
                      return (
                        <>
                          <div className="preview-video-wrap" key={index}>
                            <img
                              src={previewVideo}
                              alt="preview-video"
                              className="img"
                              onClick={() =>
                                videoPlayerHanndler(
                                  subitem?.mp4url,
                                  item?.moduleId,
                                )
                              }
                            />
                            <Typography className="test-video-name">
                              {subitem?.subModuleName}
                            </Typography>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
        })
      ) : (
        <div className="history-error-wrap">
          <img src={historyError} alt="historyerror" className="img" />
          <Typography className="history-error-text">{no_history}</Typography>
        </div>
      )}

      {videoShow && (
        <ModalVideoPlayer
          src={videoUrl}
          videoShow={videoShow}
          videoPlayerCloseHandler={videoPlayerCloseHandler}
          landscape={landscape}
        />
      )}
    </>
  );
};

export default HistoryList;
